import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/context/LanguageContext";
import { Toaster } from "@/components/ui/sonner";
import Gateway from "@/pages/Gateway";
import Dining from "@/pages/Dining";
import Distribution from "@/pages/Distribution";
import AdminLogin from "@/pages/AdminLogin";
import Admin from "@/pages/Admin";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Gateway />} />
            <Route path="/dining" element={<Dining />} />
            <Route path="/distribution" element={<Distribution />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#1A1A1A",
              color: "#FDFBF7",
              borderRadius: 0,
              border: "1px solid #1A1A1A",
              fontSize: "12px",
              letterSpacing: "0.15em",
              textTransform: "uppercase",
            },
          }}
        />
      </LanguageProvider>
    </div>
  );
}

export default App;
